import { render, staticRenderFns } from "./SummaryForm.vue?vue&type=template&id=45bb4b5d&scoped=true"
import script from "./SummaryForm.vue?vue&type=script&lang=js"
export * from "./SummaryForm.vue?vue&type=script&lang=js"
import style0 from "./SummaryForm.vue?vue&type=style&index=0&id=45bb4b5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb4b5d",
  null
  
)

export default component.exports